import store from 'store'

export const imgLoader = src => {
    if (src && typeof src === 'string') {
        const {
            user_details: { imagesBucketUrl },
        } = store.getState()
        const isRelativeLink = !(src.includes('http') || src.startsWith('/static'))
        return isRelativeLink ? imagesBucketUrl + src : src
    }
    return null
}
